import { render, staticRenderFns } from "./CSlider.vue?vue&type=template&id=0bfffc6d&scoped=true"
import script from "./CSlider.vue?vue&type=script&lang=js"
export * from "./CSlider.vue?vue&type=script&lang=js"
import style0 from "./CSlider.vue?vue&type=style&index=0&id=0bfffc6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfffc6d",
  null
  
)

export default component.exports